angular.module('Common', ['ngCookies', 'color.picker', 'foundation'])
  .run(['$rootScope', '$location', '$http', '$cookies', '$interval', 'AuthenticationService',
    function ($rootScope, $location, $http, $cookies, $interval, AuthenticationService) {
      // keep user logged in after page refresh
      $rootScope[ cookie_name ] = $cookies.getObject(cookie_name) || {};
      if ($rootScope[ cookie_name ].currentUser) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + $rootScope[ cookie_name ].currentUser.token; // jshint ignore:line
        $.ajaxSetup({
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + $rootScope[ cookie_name ].currentUser.token);
          }
        });
      }

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (toState.name != 'login' && toState.name != 'sesame-mktzap' && !$rootScope[ cookie_name ].currentUser) {
          $location.path(loginUrl);
        }
      });
      $rootScope.$on('$routeChangeSuccess', function () {
        if (typeof ga !== 'undefined') {
          ga('send', 'pageview', $location.path());
        }
      });
    }
  ])
  .config(['$httpProvider', function ($httpProvider) {
    // Http Intercpetor to check auth failures for xhr requests
    $httpProvider.interceptors.push('authHttpResponseInterceptor');
  }])
  .factory('authHttpResponseInterceptor', ['$q', '$location', '$rootScope', '$timeout', '$cookies', function ($q, $location, $rootScope, $timeout, $cookies) {
    const USER_IN_PAUSE_ERROR_CODE = '0001'

    return {
      response: function (response) {
        if (response.status === 401) {
          $location.path(loginUrl);
        }

        return response || $q.when(response);
      },
      responseError: function (rejection) {
        if (rejection.status === 409) {
          $location.path(loginUrl);
        }
        if (rejection.status === 401) {
          if (rejection.data) {
            if (rejection.data.status_code) {
              if (rejection.data.status_code == USER_IN_PAUSE_ERROR_CODE) {
                const paused = angular.fromJson(localStorage.userPauseService)
                if (paused && !paused.is_paused) {
                  localStorage.userPauseService = angular.toJson({ is_paused: true, start_pause_at: rejection.data.start_pause_at });
                }
                $rootScope.$broadcast('send_to_blockpage');
              }
            }
          }
          if (rejection.data.status_code == '0002') {
            localStorage.userPauseService = angular.toJson({ is_paused: false });
            $location.path(loginUrl);
            $timeout(function () {
              $rootScope[ cookie_name ] = {};
              $cookies.remove(cookie_name);
              $location.path(loginUrl);
              $rootScope.$broadcast('illegal_token', rejection);
            }, 2000);
          }
        }
        if (rejection.status === 402) {
          $location.path(loginUrl);
          $timeout(function () {
            $rootScope[ cookie_name ] = {};
            $cookies.remove(cookie_name);
            // $http.defaults.headers.common.Authorization = '';
            $location.path(loginUrl);
            $rootScope.$broadcast('illegal_token', rejection);
          }, 2000);
        }
        return $q.reject(rejection);
      }
    }
  }])
  .factory('AuthenticationService',
    ['Base64', '$http', '$cookies', '$rootScope', '$timeout', 'LoginService',
      function (Base64, $http, $cookies, $rootScope, $timeout, LoginService) {
        var service = {};

        service.haveCredentials = function () {
          return !!($rootScope[ cookie_name ].currentUser);
        };

        service.Login = function (username, password, callback, callback_error) {
          LoginService.login({ email: username, password: password })
               		.$promise
            .then(callback)
            .catch(callback_error);
        };

        service.SetCredentials = function (username, token) {
          $rootScope[ cookie_name ] = {
            currentUser: {
              username: username,
              token: token
            }
          };

          $http.defaults.headers.common['Authorization'] = 'Bearer ' + token; // jshint ignore:line
          $cookies.putObject(cookie_name, $rootScope[ cookie_name ], { expires: moment().add(1, 'days').toDate() });
        };

        service.ClearCredentials = function () {
          $rootScope[ cookie_name ] = {};
          $cookies.remove(cookie_name);
          $http.defaults.headers.common.Authorization = '';
        };

        return service;
      }])

  .factory('Base64', function () {
    /* jshint ignore:start */

    var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

    return {
      encode: function (input) {
        var output = '';
        var chr1; var chr2; var chr3 = '';
        var enc1; var enc2; var enc3; var enc4 = '';
        var i = 0;

        do {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);

          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;

          if (isNaN(chr2)) {
            enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
            enc4 = 64;
          }

          output = output +
                        keyStr.charAt(enc1) +
                        keyStr.charAt(enc2) +
                        keyStr.charAt(enc3) +
                        keyStr.charAt(enc4);
          chr1 = chr2 = chr3 = '';
          enc1 = enc2 = enc3 = enc4 = '';
        } while (i < input.length);

        return output;
      },

      decode: function (input) {
        var output = '';
        var chr1; var chr2; var chr3 = '';
        var enc1; var enc2; var enc3; var enc4 = '';
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) {
          window.alert('There were invalid base64 characters in the input text.\n' +
                        "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                        'Expect errors in decoding.');
        }
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

        do {
          enc1 = keyStr.indexOf(input.charAt(i++));
          enc2 = keyStr.indexOf(input.charAt(i++));
          enc3 = keyStr.indexOf(input.charAt(i++));
          enc4 = keyStr.indexOf(input.charAt(i++));

          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;

          output = output + String.fromCharCode(chr1);

          if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
          }

          chr1 = chr2 = chr3 = '';
          enc1 = enc2 = enc3 = enc4 = '';
        } while (i < input.length);

        return output;
      }
    };

    /* jshint ignore:end */
  })
  .factory('socketConnect', function ($rootScope) {
    var connect = null;
    return {
      connect: function (host) {
        if (connect !== undefined && connect !== null && connect.hasOwnProperty('io') && typeof connect.io.connect === 'function') {
          connect.io.connect();
        } else {
          connect = io.connect(host, {
            'forceNew': true,
            'reconnection': true,
            'reconnectionDelay': 1000,
            'reconnectionDelayMax': 5000,
            'reconnectionAttempts': 5,
            'timeout': 60000
          });
        }
      },
      on: function (eventName, callback) {
        connect.on(eventName, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(connect, args);
          });
        });
      },
      emit: function (eventName, data, callback) {
        connect.emit(eventName, data, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            if (callback) {
              callback.apply(connect, args);
            }
          });
        })
      },
      disconnect: function () {
        connect.disconnect();
      }
    };
  });
